import {connect} from 'react-redux';
import {genQRInfo} from "../../actions";
import React, {useRef} from "react";
import {isPicture} from "../../utils/imageUtils";
import {decodeData} from "../../utils/qrcodeHandler";

const InputText = ({dispatch}) => {
    const textRef = useRef();

    return (
        <React.Fragment>
            <div className="Qr-input-upload-div">
                <div className="Qr-input-upload">
                    <input
                        className="Qr-input big-input"
                        placeholder="http://saoban.com"
                        ref={textRef}
                        onBlur={(e) => {
                            dispatch(genQRInfo(e.target.value))
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                dispatch(genQRInfo(e.target.value));
                                e.target.blur();
                            }
                        }}
                    />
                </div>
                <div className="Qr-input-hint">
                </div>
            </div>
        </React.Fragment>);
}

export default connect()(InputText);
